import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useCallback,
} from 'react';

interface HeaderContextData {
  // Overview-specific data
  showAddListingButton?: boolean;
  onAddListing?: () => void;
  propertiesCount?: number;
}

interface HeaderContextType {
  headerData: HeaderContextData;
  setHeaderData: (data: HeaderContextData) => void;
  clearHeaderData: () => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const HeaderProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [headerData, setHeaderDataState] = useState<HeaderContextData>({});

  const setHeaderData = useCallback((data: HeaderContextData) => {
    setHeaderDataState(data);
  }, []);

  const clearHeaderData = useCallback(() => {
    setHeaderDataState({});
  }, []);

  return (
    <HeaderContext.Provider
      value={{ headerData, setHeaderData, clearHeaderData }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = (): HeaderContextType => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
};
